import { FC } from "react";
import { Button, Col, Flex, LegacyCard, Row, Typography } from "@payping/web-components";
import { getActiveReferral } from "@payping/redux/actions";
import { useAsyncFn } from "react-use";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { referralModalActivationButtonId } from "@/assets/googleTrackIds";
import { useAppDispatch } from "@/utils/redux";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";
import styles from "./styles.module.scss";

const ActivateReferral: FC = () => {
  const dispatch = useAppDispatch();
  const [{ loading: activateLoading }, onActivate] = useAsyncFn(async () => {
    await dispatch(getActiveReferral());
  }, [dispatch]);
  const { t } = useAppTranslation();

  return (
    <Flex justify={"center"}>
      <LegacyCard.Ant
        className={"tw:xs:w-4/6 tw:lg:w-3/6"}
        variant="outlined"
        style={{ boxShadow: "unset !important" }}
        cover={<img alt={"referral"} src={buildUrl(URLS.STORAGE_URL, "img/home/referralNew.svg").toString()} />}
      >
        <LegacyCard.Meta
          title={
            <Typography.Title className={""} level={5}>
              {t("referral.referralModal.title")}
            </Typography.Title>
          }
          description={
            <Row className={styles.container}>
              <Col span={24} className="tw:mb-4!">
                <div>
                  <ul>
                    <li>
                      <Typography.Text>{t("referral.referralModal.li1")}</Typography.Text>
                    </li>
                    <li>
                      <Typography.Text>{t("referral.referralModal.li2")}</Typography.Text>
                    </li>
                    <li>
                      <Typography.Text>{t("referral.referralModal.li3")}</Typography.Text>
                    </li>
                    <li>
                      <Typography.Text>{t("referral.referralModal.li4")}</Typography.Text>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col span={24}>
                <Flex justify={"center"}>
                  <Button
                    data-google-track={referralModalActivationButtonId}
                    htmlType="button"
                    variant="solid"
                    color="primary"
                    block
                    className={styles.button}
                    loading={activateLoading}
                    onClick={onActivate}
                  >
                    {t("activate")}
                  </Button>
                </Flex>
              </Col>
            </Row>
          }
        />
      </LegacyCard.Ant>
    </Flex>
  );
};

export default ActivateReferral;
